import { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";

type EmailChangeConfirmDialogProps = {
  visible: boolean;
  newEmail: string;
  onConfirm: (notify: boolean) => void;
  onCancel: () => void;
};

export function EmailChangeConfirmDialog({
  visible,
  newEmail,
  onConfirm,
  onCancel,
}: EmailChangeConfirmDialogProps) {
  const [notify, setNotify] = useState(false);

  useEffect(() => {
    if (visible) setNotify(false);
  }, [visible]);

  const footer = (
    <div>
      <Button label="Cancel" className="p-button-text" onClick={onCancel} />
      <Button label="Confirm change" onClick={() => onConfirm(notify)} autoFocus />
    </div>
  );

  return (
    <Dialog
      visible={visible}
      header="Change email address"
      draggable={false}
      onHide={onCancel}
      footer={footer}
      style={{ width: "32rem" }}
    >
      <p>
        You are changing the login email to <strong>{newEmail}</strong>. This updates
        their sign-in identity.
      </p>
      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginTop: "1rem" }}>
        <Checkbox
          inputId="notifyEmailChange"
          checked={notify}
          onChange={(e) => setNotify(!!e.checked)}
        />
        <label htmlFor="notifyEmailChange">
          Send a notification to the new email address
        </label>
      </div>
    </Dialog>
  );
}
